"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a data request field failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class InvalidBodyFieldError extends client_library_1.ExtendableError {
    constructor(field, message) {
        super(`data request: ${field} failed validation. ${message}`);
        this.field = field;
    }
}
exports.default = InvalidBodyFieldError;
//# sourceMappingURL=InvalidBodyFieldError.js.map